export enum SessionConsumers {
	DASHBOARD = 'dashboard',
	FULLSCREEN = 'fullscreen',
	AUDIO_PLAYBACK = 'audio_playback'
}
